import i18n from 'i18n';
import { ClientFields } from 'modules/clients/interfaces';

export const getClientNamePDF = (client: ClientFields | null) =>
  `${i18n.t('CLIENT_KEY')}: ${client?.name}`;

export const getClientEnvironmentNamePDF = (client: ClientFields | null) =>
  `${i18n.t('ENVIRONMENT_KEY')}: ${client?.environment?.name}`;
export const getClientLicensesPDF = (client: ClientFields | null) =>
  `${i18n.t('LICENSES_KEY')}: ${client?.licenses?.license_group
    ?.license_limit ||
    client?.licenses?.client_license?.license_limit ||
    '-'}`;
